module.exports = __webpack_public_path__ + "static/media/559.550d85fd.webp";